import { ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import type { ProgramDrill, TrainingProgram } from '@/types/training-program';
import { DrillCard } from './DrillCard';

interface DrillDetailProps {
  drill: ProgramDrill;
  program: TrainingProgram;
  onBack: () => void;
  onStart: (drillId: string) => void;
}

export function DrillDetail({ drill, program, onBack, onStart }: DrillDetailProps) {
  // UX-AUDIT-V3-203: pb-40 to ensure bottom nav is accessible below sticky CTA
  return (
    <div className="min-h-screen pb-40 bg-white">
      <header className="bg-gradient-to-r from-[#0D382A] to-[#196644] text-white">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center gap-3">
          {/* UX-AUDIT-V3-305: Back button with text "Back to Training Program" */}
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-white/90 hover:text-white transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Back to Training Program</span>
          </button>
        </div>
        <div className="max-w-7xl mx-auto px-6 pb-6">
          <p className="text-sm text-white/70">Drill Detail</p>
          <h1 className="text-2xl font-semibold">{drill.drill_name}</h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-6 space-y-6">
        <Card className="border border-[#196644]/20 bg-[#196644]/5">
          <CardContent className="space-y-2 p-4">
            <p className="text-sm text-[#196644] uppercase tracking-wide">Why am I doing this today?</p>
            <p className="text-lg font-medium text-[#0D382A]">{program.program_title}</p>
            <p className="text-sm text-gray-600">
              This drill targets your focus area: {program.primary_fault}.
            </p>
          </CardContent>
        </Card>

        <DrillCard drill={drill} variant="expanded" showActions onStart={onStart} />
      </main>

      {/* UX-AUDIT-V3-203: Position sticky CTA above bottom nav */}
      <div className="sticky bottom-16 left-0 right-0 z-40 bg-white border-t border-gray-200 p-4">
        <Button onClick={() => onStart(drill.drill_id)} className="w-full">
          Start Drill
        </Button>
      </div>
    </div>
  );
}
